const CATEGORY = {
  USER: 'User',
  COURSE_DASHBOARD: 'Course Dashboard',
  CLASSROOM: ' Classroom',
  VIDEO: 'Video',
  TOC: 'TOC',
  SLIDE: 'Slide',
  SLIDER: 'Slider',
};

export const USER_ACTIONS = {
  LOGIN: 'Click Login',
  REGISTER: 'Click Register',
  ONLINE_SOLUTION: 'Click Online Solution',
  CLEAR_BY_OD: 'Click Clear by OnDemand',
  EXTERNAL_LINK: 'Click',
  QUICK_ACCESS: 'Click Quick access',
};

export const CLASSROOM_ACTIONS = {
  RECORD_SCREEN: 'Try to Record Screen',
  MULTIPLE_SCREEN: 'Try to Connect to Multiple Screen',
  ROOTED_DEVICE: 'Try to use on Rooted device',
  EMULATOR: 'Try to use on Emulator',
  VIDEO_ERROR: 'See Video Error',
};

export const COURSE_DASHBOARD_ACTIONS = {
  ENTER_CLASSROOM: 'Enter Classroom',
};

export const VIDEO_ACTIONS = {
  PLAY: 'play',
  PAUSE: 'pause',
  SEEK: 'seek',
  PREVIOUS: 'previous',
  NEXT: 'next',
  SETTING: 'setting',
  SPEED: 'speed',
};

export const TOC_ACTIONS = {
  CLOSE: 'Close',
  OPEN: 'Open',
};

export const SLIDE_ACTIONS = {
  NEXT_SLIDE: 'Next Slide',
  PREVIOUS_SLIDE: 'Previous Slide',
  SYNC_WITH_MASTER: 'Sync with Master',
};

export const SLIDER_ACTIONS = {
  CHANGE: 'Change',
};

export const genUserEvent = (action, label) => ({
  category: CATEGORY.USER,
  action,
  label,
});

export const genCourseDashboardEvent = (action, label) => ({
  category: CATEGORY.COURSE_DASHBOARD,
  action,
  label,
});

export const genClassroomEvent = (action, label) => ({
  category: CATEGORY.CLASSROOM,
  action,
  label,
});

export const genVideoEvent = (action, label) => ({
  category: CATEGORY.VIDEO,
  action,
  label,
});

export const genTOCEvent = (action, label) => ({
  category: CATEGORY.TOC,
  action,
  label,
});

export const genSlideEvent = (action, label) => ({
  category: CATEGORY.SLIDE,
  action,
  label,
});

export const genSliderEvent = (action, label) => ({
  category: CATEGORY.SLIDER,
  action,
  label,
});
